<template>
    <div class="container">
        <div class="row">
            <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
                <div class="account-box text-center">
                    <router-link to="/" class="logo">
                        <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                    </router-link>
                    <div class="account-box-title text-center">خوش آمدید</div>
                    <div class="account-box-content">
                        <div class="account-box-message">
                            <i class="account-box-message-icon now-ui-icons users_single-02"></i>
                            <h3>رمز حساب کاربری شما با موفقیت تغییر یافت</h3>
                            <p>
                                اکنون می‌توانید به صفحه‌ای که در آن بودید بازگردید و یا با تکمیل اطلاعات حساب کاربری
                                خود به کلیه امکانات و
                                سرویس‌ها دسترسی داشته باشید
                            </p>
                            <ul class="account-box-message-links">
                                <li>
                                    <div class="parent-btn">
                                        <router-link to="/info" class="dk-btn dk-btn-info">
                                            تکمیل  یا تغییر حساب کاربری
                                            <i class="now-ui-icons users_single-02"></i>
                                        </router-link>
                                    </div>
                                </li>
                                <li><router-link tag="a" to="/" class="btn-link-border">بازگشت به صفحه‌ای اصلی</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        } 

    }
</script>

<style scoped>
</style>